module.exports = __webpack_public_path__ + "f15241200f1893e9290b8b424951b119.svg";